<section class="f-col f-main-center f-cross-center">
    <h1 class="mat-headline-4 m-0">Search</h1>
    <div class="floating-control">
        <mat-icon class="mx-5">search</mat-icon>
        <input [formControl]="query" matInput placeholder="Search for brands, cities and/or outlets..."/>
        @if(query.value){
            <mat-icon class="mx-5 clickable" paint="warn" (click)="query.setValue('')">close</mat-icon>
        }
    </div>
    <br/>
</section>
<div class="content">
    @if(search()){
        <item-grid [items]="brands()" (loadMore)="loadMore()" [isFinal]="final()" item_name="Brands" [item_width]="315" [item_template]="itemTemplate" [loading]="loading()">
            <ng-template #itemTemplate let-item>
                <brand-card class="f-main-center" [brand]="item"></brand-card>
            </ng-template>
        </item-grid>
    } @else {
        <item-grid [items]="categories()||[]" [isFinal]="true" item_name="Categories" [item_width]="300" [item_template]="itemTemplate" [loading]="loading()">
            <ng-template #itemTemplate let-category let-index="index">
                    @let url = category.image_url ? (('/categories' + category.image_url) | bucket:true) : 'images/fallback/banner.webp';
                    <a [routerLink]="['/search']" [queryParams]="{ s: category.name }" class="category-card" [class.featured]="!index" draggable="false">
                        <img class="category-background" [src]="url" [alt]="category.name" draggable="false"/>
                        <button class="cosmetic category-icon" mat-mini-fab draggable="false">
                            <mat-icon [svgIcon]="category.slug"></mat-icon>
                        </button>
                        <h3 class="category-name font-extrabold text-center" paint="white">{{category.name}}</h3>
                    </a>
            </ng-template>
        </item-grid>
    }
</div>